import { SLIDES_ATIVOS } from '../data/slides-ativos-query'
import { linkDownloadByArquivoQueryGql } from '@/core/components/uploader-utils'
import { useQuery } from '@tanstack/react-query'
import { useCallback, useEffect, useState } from 'react'
import { request } from '../../../core/utils/request'
import {
  LinkDownloadByArquivoQueryQuery,
  LinkDownloadByArquivoQueryQueryVariables,
  SlidesAtivosQueryQuery
} from '../../../core/types/graphql'

export const useCarousel = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['slidesAtivos'],
    queryFn: async () => await request<SlidesAtivosQueryQuery>(SLIDES_ATIVOS)
  })

  const [images, setImages] = useState([])

  const loadImages = useCallback(async () => {
    const loadedImages = await Promise.all(
      (data?.slidesAtivos ?? []).map(async slide => {
        const {
          titulo,
          corTitulo,
          tamanhoTitulo,
          subtitulo,
          corSubtitulo,
          tamanhoSubtitulo,
          tituloBotao,
          link,
          linkTarget,
          arquivo
        } = slide ?? {}

        const { linkDownloadByArquivo } = await request<
          LinkDownloadByArquivoQueryQuery,
          LinkDownloadByArquivoQueryQueryVariables
        >(linkDownloadByArquivoQueryGql, {
          variables: { idArquivo: arquivo?.id ?? '' }
        })

        return {
          src: linkDownloadByArquivo,
          alt: titulo,
          title: {
            text: titulo,
            color: corTitulo,
            size: `${tamanhoTitulo}px`
          },
          subtitle: {
            text: subtitulo,
            color: corSubtitulo,
            size: `${tamanhoSubtitulo}px`
          },
          button:
            (tituloBotao ?? '').length > 0
              ? { title: tituloBotao, link, target: linkTarget }
              : undefined
        }
      })
    )
    setImages(loadedImages)
  }, [data?.slidesAtivos])

  useEffect(() => {
    loadImages().then()
  }, [data?.slidesAtivos, loadImages])

  return {
    isLoading,
    data,
    images
  }
}
